import { DownIcon } from '@/_assets/icon-components';
import { Button } from '@/components/ui/button';
import { Text } from '@chakra-ui/react';
import { MapPin } from 'lucide-react';
import React from 'react';

type Props = {
  open: boolean;
  primarySubtle: string;
  label: React.ReactNode;
};

const LocationPopoverTrigger: React.FC<Props> = ({
  open,
  primarySubtle,
  label,
}) => {
  return (
    <Button
      gap={2}
      size='xl'
      h='48px'
      rounded='full'
      variant='subtle'
      display='flex'
      alignItems='center'
      bg={open ? primarySubtle : 'gray.400'}
      fontWeight={500}
      color='text'
      borderColor={open ? 'primary' : 'transparent'}
      _hover={{ bgColor: primarySubtle, borderColor: 'primary' }}
      _active={{ bgColor: primarySubtle, borderColor: 'primary' }}
    >
      <Text as='span' color='text'>
        <MapPin strokeWidth={1.5} />
      </Text>

      <Text maxW='150px' truncate>
        {label}
      </Text>

      <DownIcon />
    </Button>
  );
};

export default LocationPopoverTrigger;
